import { AxiosResponse } from "axios";
import { EEAverageAndMedianRemuneration } from "../../../Model/Dto/EmploymentEquity/AverageAndMedianRemuneration/AverageAndMedianRemuneration";
import { axiosCoreInstance } from "../../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrls.AverageAndMedianRemuneration";

export const AverageAndMedianRemunerationService = {
    GetReport: (ScorecardId: string): 
        Promise<AxiosResponse<EEAverageAndMedianRemuneration.DtoIn>> => 
            axiosCoreInstance.get(`${ApiUrls.GetReport}/${ScorecardId}`),
    SaveReport: (report: EEAverageAndMedianRemuneration.DtoOut): 
        Promise<AxiosResponse<EEAverageAndMedianRemuneration.DtoOut>> => 
            axiosCoreInstance.post(ApiUrls.SaveReport, report),
    RecalculateEarnerValues: (request: string): 
        Promise<AxiosResponse<EEAverageAndMedianRemuneration.DtoIn>> => 
            axiosCoreInstance.get(`${ApiUrls.RecalculateTopBottomMedianEarnerValues.replace('ScorecardId', request)}`),
    TopOrBottomEarners: (request: EEAverageAndMedianRemuneration.TopAndBottomEarnerRequest): 
        Promise<AxiosResponse<EEAverageAndMedianRemuneration.TopAndBottomEarnerSearchResponse>> => 
            axiosCoreInstance.post(`${ApiUrls.TopOrBottomEarners.replace('ScorecardId', request.scorecardId)}`, request),
    TopOrBottomEarnersRange: (request: EEAverageAndMedianRemuneration.TopAndBottomEarnerRequest, isUpperRangeLimit: boolean): 
        Promise<AxiosResponse<EEAverageAndMedianRemuneration.TopAndBottomEarnerSearchResponse>> => 
            axiosCoreInstance.post(`${ApiUrls.TopOrBottomEarnersRange.replace('ScorecardId', request.scorecardId)}?isUpperRangeLimit=${isUpperRangeLimit}`, request),
    MedianEarners: (request: EEAverageAndMedianRemuneration.TopAndBottomEarnerRequest): 
        Promise<AxiosResponse<EEAverageAndMedianRemuneration.TopAndBottomEarnerSearchResponse>> => 
            axiosCoreInstance.post(`${ApiUrls.MedianEarners.replace('ScorecardId', request.scorecardId)}`, request),
    SaveUserCapturedValues: (request: EEAverageAndMedianRemuneration.UserCapturedFields): 
        Promise<AxiosResponse<EEAverageAndMedianRemuneration.UserCapturedFields>> => 
           axiosCoreInstance.post(`${ApiUrls.SaveUserCapturedValues.replace('ScorecardId', request.ScorecardId)}`, request),
}
